var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3531 13.4469L14.9973 8.80266",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5729 10.1671C2.79961 9.78048 2.89331 8.64827 3.71965 8.39401L18.87 3.73235C19.6054 3.5061 20.2941 4.19483 20.0678 4.93013L15.4062 20.0805C15.1519 20.9069 14.0197 21.0006 13.6331 20.2273L10.4225 13.8062C10.3298 13.6208 10.1794 13.4704 9.99395 13.3777L3.5729 10.1671Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendUpRight);
export default __webpack_public_path__ + "static/media/Send_Up_Right.fb710f1ac446fc8666eeaed796561bdb.svg";
export { ForwardRef as ReactComponent };